export default function () {
}



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/resources/mounted.js